<template>
  <div>
    <component :is="labelTag" :class="`checkbox__item ${rowClass}`">
      <span v-if="loading" class="flex color-complementary-300">
        <mdicon name="loading" size="20" class="spinner" />
      </span>
      <b-form-checkbox
        v-else
        v-model="checkboxValue"
        :size="size"
        :value="checkedValue"
        :unchecked-value="uncheckedValue"
        :disabled="disabled"
        @change="change"
      />
      <span :class="`checkbox__item-label ${labelClass}`">
        {{ label }}
        <span v-if="infoTooltip" v-b-tooltip.hover :title="infoTooltip">
          <mdicon name="help-circle-outline" size="16" />
        </span>
      </span>
    </component>
  </div>
</template>

<script>
export default {
  props: {
    value: {}, // watch model
    item: {
      type: [Object, String, Number],
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    checkedValue: {
      type: [Boolean, Number],
      default: true,
    },
    uncheckedValue: {
      type: [Boolean, Number],
      default: false,
    },
    size: {
      type: String,
      default: "lg",
    },
    rowClass: {
      type: String,
      default: "padding-x-8 margin-bottom-8",
    },
    labelClass: {
      type: String,
      default: "",
    },
    infoTooltip: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    labelTag: {
      type: String,
      default: "div",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checkboxValue: {
      /* guidance: watching input value */
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", this.name, val);
      },
    },
  },
  methods: {
    change(state) {
      this.$emit("change", state, this.item);
    },
  },
};
</script>
